// extracted by mini-css-extract-plugin
export default {"container":"singlePlaylist_container__0mT24"};